// extracted by mini-css-extract-plugin
export default {"datatable_wrapper":"Tabela_datatable_wrapper__rOIVF"};